import React, { ChangeEvent } from 'react';
import classnames from 'classnames';

import styles from './text-area.css';

interface TextAreaProps {
  /** Default value of the text area */
  children?: string;
  /** Disables Text Area disallowing interaction */
  disabled?: boolean;
  /** Adds required attribute */
  required?: boolean;
  /** Displays placeholder text inside the input field */
  placeholder?: string;
  /** Adds additional classes to the component. */
  className?: string;
  /** Name added to the input field in the HTML Markup */
  name?: string;
  /** Text Area value (it should be accompanied by an onChange function) */
  value?: string;
  /** Callback when blured */
  onBlur?: () => void;
  /** Callback when typed on */
  onChange?: (event: ChangeEvent<HTMLTextAreaElement>) => void;
  /** Sets the width of the Text Area */
  width?: string;
  /** Sets the height of the Text Area */
  height?: string;
  /** Provides a data-testid */
  'data-testid'?: string;
}

const DEFAULT_HEIGHT = '120px';

/**
 * Text Area component
 *
 * @param {TextAreaProps} props
 *
 * @returns JSX.ELEMENT
 */
const TextArea = ({
  children,
  placeholder,
  className,
  name,
  value,
  onBlur,
  onChange,
  'data-testid': dataTestId,
  required,
  disabled = false,
  width = '100%',
  height = DEFAULT_HEIGHT
}: TextAreaProps) => {
  const textAreaClasses = classnames(styles.textArea, className, {
    [styles.disabled]: disabled
  });
  return (
    <textarea
      className={textAreaClasses}
      required={required}
      disabled={disabled}
      style={{ width, height }}
      defaultValue={children}
      {...(placeholder ? { placeholder } : {})}
      {...(name ? { name } : {})}
      {...(value !== undefined ? { value } : {})}
      {...(!disabled && typeof onBlur === 'function' ? { onBlur } : {})}
      {...(!disabled && typeof onChange === 'function' ? { onChange } : {})}
      data-testid={dataTestId}
    />
  );
};

TextArea.defaultProps = {};

export default TextArea;
